// ======================================================================
// File Name       : SelectGroupDialog
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { connect } from 'react-redux';
import { Modal, Form, Col, Button } from 'react-bootstrap';
import * as userActions from '../../actions/UserAction';
import { MESSAGE_TYPE, MESSAGE_TIME_OUT, MODAL_SIZE } from '../../constants/index';
import GroupTree from '../../components/group/GroupTree';
import * as groupActions from '../../actions/GroupAction';
import { isSuperUser } from '../../utils';

class SelectGroupDlg extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTargetGroup: {},
    };
    this.handleSelectNode = this.handleSelectNode.bind(this);
    this.handleSelectCheckBox = this.handleSelectCheckBox.bind(this);
  }

  componentWillMount() {
    const { dispatch, groupList } = this.props;
    if (!groupList || (groupList && groupList.length <= 0)) {
      this.props.dispatch(groupActions.fetchGroupStructure());
    }
  }

  /**
   * Handle event when click on OK of select group dialog
   *
   */
  onOK() {
    this.props.onOK(this.state.selectedTargetGroup);
  }

  /**
   * Handle select node
   *
   * @param {*} event
   * @param {object} node
   */
  handleSelectNode(event, node) {
    if (!node) return;
    this.setState({
      selectedTargetGroup: node.data,
    });
  }

  handleSelectCheckBox(event, node) {
    if (!node) return;
    this.setState({
      selectedTargetGroup: node,
    });
  }

  /**
   * Render GUI
   * @returns {XML}
   */
  render() {
    const style = {
      background: 'none',
      width: 'auto',
      marginLeft: 0,
      left: 0,
    };
    return (
      <Modal
        className="modal-container"
        show={this.props.showModal}
        size={MODAL_SIZE.lg}
        style={style}
      >
        <Modal.Header onHide={this.props.onCancel} closeButton>
          <Modal.Title className="text-center margin-top-10">ユーザーグループを選択してください</Modal.Title>
        </Modal.Header>
        <Modal.Body className="padding-10">
          <Col sm={12}>
            <Form className='form-horizontal'>
              <GroupTree
                groupList={this.props.groupList}
                selectedGroup={this.props.selectedGroup}
                handleSelectNode={this.handleSelectNode}
                handleSelectCheckBox={this.handleSelectCheckBox}
                isCheckBox={this.props.isCheckBox}
              />
            </Form>
          </Col>
        </Modal.Body>
        <Modal.Footer className="text-center">
          <Button variant="default" className="btn-96 margin-10" onClick={this.props.onCancel}>
            キャンセル
          </Button>
          <Button variant="primary" className="btn-96 margin-10" onClick={this.onOK.bind(this)}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { group, authed } = state;
  const { groupList } = group;
  const { userInfo } = authed.authedUser;
  return {
    groupList,
    userInfo,
  };
};

export default connect(mapStateToProps)(SelectGroupDlg);
